import React from "react";

export const Help: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon"
    >
      <path
        fill="#004B96"
        fill-rule="nonzero"
        d="M31.917 15.958C31.917 7.158 24.757 0 15.958 0 7.158 0 0 7.159 0 15.958c0 2.868.763 5.66 2.213 8.112L.059 31.858l7.788-2.154a15.909 15.909 0 008.111 2.213c8.8 0 15.959-7.16 15.959-15.959zm-18.408-3.714h-2.448c0-2.7 2.197-4.897 4.897-4.897 2.701 0 4.898 2.196 4.898 4.897a4.91 4.91 0 01-1.593 3.614l-2.08 1.905v1.91h-2.45v-2.989l2.877-2.632c.514-.47.797-1.112.797-1.808a2.452 2.452 0 00-2.449-2.449 2.452 2.452 0 00-2.449 2.45zm1.225 9.877h2.449v2.449h-2.45v-2.449z"
      />
    </svg>
  );
};
